/* Envolvo — scripts propios (prefijo mt-) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initComparador() {
    document.querySelectorAll('[data-mt-comparador]').forEach(function (comp) {
      var range = comp.querySelector('.mt-ad__range');
      if (!range) return;
      var set = function () { comp.style.setProperty('--pos', range.value + '%'); };
      range.addEventListener('input', set);
      set();
    });
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-mt-parallax]');
    if (!imgs.length || reduce) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var r = img.getBoundingClientRect();
        var k = parseFloat(img.getAttribute('data-mt-parallax')) || 0;
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * -k / 100;
        img.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initCifras() {
    var els = document.querySelectorAll('[data-mt-cifra]');
    if (!els.length) return;
    var animar = function (el) {
      var fin = parseFloat(el.getAttribute('data-mt-cifra')) || 0;
      var dec = (String(fin).split('.')[1] || '').length;
      var suf = el.getAttribute('data-mt-sufijo') || '';
      if (reduce) { el.textContent = fin.toFixed(dec) + suf; return; }
      var t0 = null, dur = 1600;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = fin * (1 - Math.pow(1 - p, 3));
        el.textContent = v.toFixed(dec).replace('.', ',') + suf;
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initProducto() {
    var root = document.querySelector('[data-mt-producto]');
    if (!root) return;

    // Galería
    var principal = root.querySelector('.mt-pp__principal img');
    var minis = root.querySelectorAll('.mt-pp__mini');
    function mostrar(src, srcset, alt) {
      if (!principal) return;
      principal.style.opacity = 0;
      setTimeout(function () {
        principal.src = src;
        if (srcset) principal.srcset = srcset; else principal.removeAttribute('srcset');
        principal.alt = alt || '';
        principal.style.opacity = 1;
      }, 150);
    }
    minis.forEach(function (b) {
      b.addEventListener('click', function () {
        minis.forEach(function (x) { x.classList.remove('is-activa'); });
        b.classList.add('is-activa');
        mostrar(b.getAttribute('data-src'), b.getAttribute('data-srcset'), b.getAttribute('data-alt'));
      });
    });

    // Variantes
    var dataEl = root.querySelector('[data-mt-variantes]');
    var variantes = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = root.querySelector('input[name="id"]');
    var boton = root.querySelector('[data-mt-anadir]');
    var precio = document.querySelectorAll('[data-mt-precio]');
    var antes = root.querySelectorAll('[data-mt-antes]');
    var ahorro = root.querySelector('[data-mt-ahorro]');
    var fmt = root.getAttribute('data-mt-moneda') || '{{amount_with_comma_separator}} €';
    var txtAnadir = boton ? boton.getAttribute('data-texto') : '';
    var txtAgotado = boton ? boton.getAttribute('data-agotado') : '';

    function dinero(cents) {
      var n = (cents / 100).toFixed(2);
      var conComa = n.replace('.', ',');
      return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
                .replace(/\{\{\s*amount\s*\}\}/, n)
                .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }

    function actualizar() {
      var sel = [];
      root.querySelectorAll('.mt-pp__opcion').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        sel.push(c ? c.value : null);
        var lbl = fs.querySelector('legend span');
        if (lbl && c) lbl.textContent = c.getAttribute('data-trad') || c.value;
      });
      var v = variantes.find(function (x) {
        return x.options.every(function (o, i) { return o === sel[i]; });
      });
      if (!v) return;
      actual = v;
      root.querySelectorAll('[data-mt-pack-variante]').forEach(function (s) { s.value = String(v.id); });
      actualizarPacks();
      if (idInput) idInput.value = v.id;
      precio.forEach(function (p) { p.textContent = dinero(v.price); });
      var hayAntes = v.compare_at_price && v.compare_at_price > v.price;
      antes.forEach(function (a) { a.textContent = hayAntes ? dinero(v.compare_at_price) : ''; a.hidden = !hayAntes; });
      if (ahorro) {
        ahorro.hidden = !hayAntes;
        if (hayAntes) ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
      }
      if (boton) {
        boton.disabled = !v.available;
        var span = boton.querySelector('span');
        if (span) span.textContent = v.available ? txtAnadir : txtAgotado;
      }
      if (v.featured_media_id) {
        var mini = root.querySelector('.mt-pp__mini[data-media-id="' + v.featured_media_id + '"]');
        if (mini) mini.click();
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.querySelectorAll('.mt-pp__opcion input').forEach(function (i) { i.addEventListener('change', actualizar); });

    // Packs (1, 2, 3 unidades con descuento automático de Shopify)
    var actual = null;
    if (idInput) {
      actual = variantes.find(function (x) { return String(x.id) === String(idInput.value); }) || null;
    }
    var packs = root.querySelectorAll('.mt-pack');
    var cantInput = root.querySelector('input[name="quantity"]');
    function packActivo() {
      var r = root.querySelector('.mt-pack input[type="radio"]:checked');
      return r ? { qty: parseInt(r.value, 10) || 1, pct: parseFloat(r.getAttribute('data-pct')) || 0, el: r.closest('.mt-pack') } : null;
    }
    function actualizarPacks() {
      packs.forEach(function (p) {
        var r = p.querySelector('input[type="radio"]');
        p.classList.toggle('is-activo', r.checked);
        if (!actual) return;
        var qty = parseInt(r.value, 10) || 1;
        var pct = parseFloat(r.getAttribute('data-pct')) || 0;
        var total = (actual.price - Math.floor(actual.price * pct / 100)) * qty;
        var ref = (actual.compare_at_price && actual.compare_at_price > actual.price) ? actual.compare_at_price : actual.price;
        var antes = ref * qty;
        var pe = p.querySelector('[data-mt-pack-precio]');
        var ae = p.querySelector('[data-mt-pack-antes]');
        if (pe) pe.textContent = dinero(total);
        if (ae) { ae.textContent = dinero(antes); ae.hidden = !(antes > total); }
      });
      var pa = packActivo();
      if (pa && cantInput) cantInput.value = pa.qty;
    }
    packs.forEach(function (p) {
      p.querySelector('input[type="radio"]').addEventListener('change', actualizarPacks);
      p.querySelectorAll('select').forEach(function (s) {
        s.addEventListener('click', function (e) { e.stopPropagation(); });
        s.addEventListener('change', function () {
          var r = p.querySelector('input[type="radio"]');
          if (!r.checked) { r.checked = true; actualizarPacks(); }
        });
      });
    });
    if (packs.length) actualizarPacks();

    // Envío de packs con colores mezclados: varias líneas al carrito
    var pf = root.querySelector('[data-mt-pf]');
    if (pf && packs.length) {
      pf.addEventListener('submit', function (e) {
        var pa = packActivo();
        if (!pa || pa.qty < 2) return; // 1 unidad: lo gestiona el formulario normal
        var selects = pa.el.querySelectorAll('[data-mt-pack-variante]');
        if (!selects.length) return; // sin variantes: basta con la cantidad
        e.preventDefault();
        e.stopPropagation();
        var cuenta = {};
        selects.forEach(function (s) { cuenta[s.value] = (cuenta[s.value] || 0) + 1; });
        var items = Object.keys(cuenta).map(function (id) { return { id: parseInt(id, 10), quantity: cuenta[id] }; });
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var body = { items: items };
        if (cart && cart.getSectionsToRender) {
          body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        if (boton) { boton.setAttribute('aria-disabled', 'true'); boton.classList.add('loading'); }
        var spin = pf.querySelector('.loading__spinner');
        if (spin) spin.classList.remove('hidden');
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              var w = pf.querySelector('.product-form__error-message-wrapper');
              var m = pf.querySelector('.product-form__error-message');
              if (w && m) { m.textContent = res.description || res.message; w.hidden = false; }
              return;
            }
            if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0].id, cartData: res });
            }
            cart.classList.remove('is-empty');
            cart.renderContents(res);
          })
          .catch(function () { window.location = '/cart'; })
          .finally(function () {
            if (boton) { boton.removeAttribute('aria-disabled'); boton.classList.remove('loading'); }
            if (spin) spin.classList.add('hidden');
          });
      }, true);
    }

    // Cantidad
    var cant = root.querySelector('.mt-pp__cant input');
    root.querySelectorAll('[data-mt-cant]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(cant.value, 10) || 1;
        n += parseInt(b.getAttribute('data-mt-cant'), 10);
        cant.value = Math.max(1, n);
      });
    });

    // Barra sticky móvil
    var sticky = document.querySelector('.mt-sticky');
    var form = root.querySelector('.mt-pp__comprar');
    if (sticky && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', pasado);
        });
      }).observe(form);
      var sb = sticky.querySelector('button');
      if (sb) sb.addEventListener('click', function () {
        if (boton && !boton.disabled) boton.click();
        else form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  function initAll() {
    initReveal();
    initComparador();
    initParallax();
    initCifras();
    initProducto();
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
